import * as Mod1 from "./discourse/admin-discourse-events-calendar-plugin-route-map";
import * as Mod2 from "./discourse/blocks/dec-upcoming-events";
import * as Mod3 from "./discourse/components/dec-event-preview-popover";
import * as Mod4 from "./discourse/components/reviewable/dec-event";
import * as Mod5 from "./discourse/components/upsert-category/events-calendar";
import * as Mod6 from "./discourse/connectors/after-create-topic-button/dec-new-event-button.gjs";
import * as Mod7 from "./discourse/connectors/category-custom-settings/dec-events-settings.gjs";
import * as Mod8 from "./discourse/connectors/full-page-search-before-results/discourse-events-calendar-results.gjs";
import * as Mod9 from "./discourse/connectors/search-menu-results-bottom/discourse-events-calendar-results.gjs";
import * as Mod10 from "./discourse/connectors/topic-above-posts/dec-topic-event-summary.gjs";
import * as Mod11 from "./discourse/connectors/user-preferences-nav/events-calendar-preferences.gjs";
import * as Mod12 from "./discourse/controllers/discourse-events-calendar-event";
import * as Mod13 from "./discourse/controllers/discourse-events-calendar-location";
import * as Mod14 from "./discourse/controllers/discourse-events-calendar-locations";
import * as Mod15 from "./discourse/controllers/discourse-events-calendar-room";
import * as Mod16 from "./discourse/controllers/discourse-events-calendar-rooms";
import * as Mod17 from "./discourse/controllers/discourse-events-calendar";
import * as Mod18 from "./discourse/discourse-events-calendar-route-map";
import * as Mod19 from "./discourse/events-calendar-preferences-route-map";
import * as Mod20 from "./discourse/initializers/dec-onebox-rsvp";
import * as Mod21 from "./discourse/initializers/discourse-events-calendar-admin-plugin-configuration-nav";
import * as Mod22 from "./discourse/initializers/discourse-events-calendar-category-tab";
import * as Mod23 from "./discourse/initializers/discourse-events-calendar-search";
import * as Mod24 from "./discourse/initializers/discourse-events-calendar-sidebar";
import * as Mod25 from "./discourse/initializers/discourse-events-calendar-upcoming-events";
import * as Mod26 from "./discourse/lib/dec-event-batches";
import * as Mod27 from "./discourse/lib/dec-event-url";
import * as Mod28 from "./discourse/lib/dec-hours";
import * as Mod29 from "./discourse/lib/dec-image-upload";
import * as Mod30 from "./discourse/lib/dec-onebox-rsvp";
import * as Mod31 from "./discourse/lib/dec-safe-url";
import * as Mod32 from "./discourse/lib/safe-render-blocks";
import * as Mod33 from "./discourse/modifiers/dec-dismiss-menu";
import * as Mod34 from "./discourse/modifiers/dec-dismiss-on-outside";
import * as Mod35 from "./discourse/routes/discourse-events-calendar-event";
import * as Mod36 from "./discourse/routes/discourse-events-calendar-location";
import * as Mod37 from "./discourse/routes/discourse-events-calendar-locations";
import * as Mod38 from "./discourse/routes/discourse-events-calendar-room";
import * as Mod39 from "./discourse/routes/discourse-events-calendar-rooms";
import * as Mod40 from "./discourse/routes/discourse-events-calendar";
import * as Mod41 from "./discourse/routes/preferences/events-calendar-subscriptions";
import * as Mod42 from "./discourse/routes/preferences/external-calendars";
import * as Mod43 from "./discourse/templates/discourse-events-calendar-event-loading";
import * as Mod44 from "./discourse/templates/discourse-events-calendar-event";
import * as Mod45 from "./discourse/templates/discourse-events-calendar-location-loading";
import * as Mod46 from "./discourse/templates/discourse-events-calendar-location";
import * as Mod47 from "./discourse/templates/discourse-events-calendar-locations";
import * as Mod48 from "./discourse/templates/discourse-events-calendar-room-loading";
import * as Mod49 from "./discourse/templates/discourse-events-calendar-room";
import * as Mod50 from "./discourse/templates/discourse-events-calendar-rooms";
import * as Mod51 from "./discourse/templates/discourse-events-calendar";
import * as Mod52 from "./discourse/templates/preferences/events-calendar-subscriptions";
import * as Mod53 from "./discourse/templates/preferences/external-calendars";
const compatModules = {
  "discourse/admin-discourse-events-calendar-plugin-route-map": Mod1,
  "discourse/blocks/dec-upcoming-events": Mod2,
  "discourse/components/dec-event-preview-popover": Mod3,
  "discourse/components/reviewable/dec-event": Mod4,
  "discourse/components/upsert-category/events-calendar": Mod5,
  "discourse/connectors/after-create-topic-button/dec-new-event-button": Mod6,
  "discourse/connectors/category-custom-settings/dec-events-settings": Mod7,
  "discourse/connectors/full-page-search-before-results/discourse-events-calendar-results": Mod8,
  "discourse/connectors/search-menu-results-bottom/discourse-events-calendar-results": Mod9,
  "discourse/connectors/topic-above-posts/dec-topic-event-summary": Mod10,
  "discourse/connectors/user-preferences-nav/events-calendar-preferences": Mod11,
  "discourse/controllers/discourse-events-calendar-event": Mod12,
  "discourse/controllers/discourse-events-calendar-location": Mod13,
  "discourse/controllers/discourse-events-calendar-locations": Mod14,
  "discourse/controllers/discourse-events-calendar-room": Mod15,
  "discourse/controllers/discourse-events-calendar-rooms": Mod16,
  "discourse/controllers/discourse-events-calendar": Mod17,
  "discourse/discourse-events-calendar-route-map": Mod18,
  "discourse/events-calendar-preferences-route-map": Mod19,
  "discourse/initializers/dec-onebox-rsvp": Mod20,
  "discourse/initializers/discourse-events-calendar-admin-plugin-configuration-nav": Mod21,
  "discourse/initializers/discourse-events-calendar-category-tab": Mod22,
  "discourse/initializers/discourse-events-calendar-search": Mod23,
  "discourse/initializers/discourse-events-calendar-sidebar": Mod24,
  "discourse/initializers/discourse-events-calendar-upcoming-events": Mod25,
  "discourse/lib/dec-event-batches": Mod26,
  "discourse/lib/dec-event-url": Mod27,
  "discourse/lib/dec-hours": Mod28,
  "discourse/lib/dec-image-upload": Mod29,
  "discourse/lib/dec-onebox-rsvp": Mod30,
  "discourse/lib/dec-safe-url": Mod31,
  "discourse/lib/safe-render-blocks": Mod32,
  "discourse/modifiers/dec-dismiss-menu": Mod33,
  "discourse/modifiers/dec-dismiss-on-outside": Mod34,
  "discourse/routes/discourse-events-calendar-event": Mod35,
  "discourse/routes/discourse-events-calendar-location": Mod36,
  "discourse/routes/discourse-events-calendar-locations": Mod37,
  "discourse/routes/discourse-events-calendar-room": Mod38,
  "discourse/routes/discourse-events-calendar-rooms": Mod39,
  "discourse/routes/discourse-events-calendar": Mod40,
  "discourse/routes/preferences/events-calendar-subscriptions": Mod41,
  "discourse/routes/preferences/external-calendars": Mod42,
  "discourse/templates/discourse-events-calendar-event-loading": Mod43,
  "discourse/templates/discourse-events-calendar-event": Mod44,
  "discourse/templates/discourse-events-calendar-location-loading": Mod45,
  "discourse/templates/discourse-events-calendar-location": Mod46,
  "discourse/templates/discourse-events-calendar-locations": Mod47,
  "discourse/templates/discourse-events-calendar-room-loading": Mod48,
  "discourse/templates/discourse-events-calendar-room": Mod49,
  "discourse/templates/discourse-events-calendar-rooms": Mod50,
  "discourse/templates/discourse-events-calendar": Mod51,
  "discourse/templates/preferences/events-calendar-subscriptions": Mod52,
  "discourse/templates/preferences/external-calendars": Mod53,
};
export { compatModules };
export default compatModules;
